import { render, staticRenderFns } from "./DetectTipModal.vue?vue&type=template&id=3a8ce23a&scoped=true&"
import script from "./DetectTipModal.vue?vue&type=script&lang=js&"
export * from "./DetectTipModal.vue?vue&type=script&lang=js&"
import style0 from "./DetectTipModal.vue?vue&type=style&index=0&id=3a8ce23a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8ce23a",
  null
  
)

export default component.exports